import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export const usePaymentStatus = (sessionId) => {
  const [state, setState] = useState("pending");
  const [livemode, setLivemode] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    let timer;
    let attempts = 0;
    setLivemode(null);
    setState("pending");
    const poll = async () => {
      if (!sessionId) { setState("error"); return; }
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${encodeURIComponent(sessionId)}`, { signal: controller.signal });
        if (controller.signal.aborted) return;
        if (data.payment_status === "paid") {
          setLivemode(data.livemode);
          setState("paid");
          return;
        }
        if (["refunded", "partially_refunded"].includes(data.payment_status)) { setState("refunded"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch (err) {
        if (controller.signal.aborted) return;
        if (err.response?.status === 404) { setState("error"); return; }
        // Retry temporary connection errors; do not infer a debit outcome.
      }
      if (attempts < 6) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => { controller.abort(); clearTimeout(timer); };
  }, [sessionId, retryCount]);
  return { state, livemode, retry: () => setRetryCount((value) => value + 1) };
};